import { Flex, Typography } from "antd"
import { useLocation, useNavigate } from "react-router"

import Icon from "../../Icon"
import ButtonComponent from "../Button/index"

const { Text } = Typography

const StripeTokenModal = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const onClose = () => {
    navigate(pathname, { replace: true })
  }
  return (
    <Flex className="stripe-token-help-modal" align="center" justify="center" onClick={onClose}>
      <Flex
        className="modal-content"
        vertical
        align="center"
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        <Icon className="error_icon" type="help_modal_error" />
        <Flex vertical gap={8} align="center">
          <Text className="header">Stripe connection failed</Text>
          <Text type="secondary">
            We couldn’t connect your Stripe account because it appears to be restricted or rejected
            by Stripe.
            <br />
            Please contact Stripe Support to resolve this issue and try again once it’s fixed.
          </Text>
        </Flex>
        <ButtonComponent type="primary" size="large" onClick={onClose} style={{ marginTop: 24 }}>
          Close
        </ButtonComponent>
      </Flex>
    </Flex>
  )
}

export default StripeTokenModal
